import React, { Component } from 'react';
import { Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { find, get } from 'lodash';
import { Link } from 'react-router-dom';
//import ComparisonDetails from './Details';
import ComparisonRows from './ComparisonRows';
import sample from './sample.json';
import IncomeChart from '../../components/pages/comparison/IncomeChart';
import SearchWidget from '../../components/pages/home/SearchWidget';

class ComparisonList extends Component {
	constructor(props) {
		super(props);
		const months = 3;
		const entities = [];
		
		this.state = {
			months,
			baseEntity: null,
			entities
		};
		
	}
	
	addEntity = (entity) => {
		let { entities, months } = this.state;
		entity = this.formatEntity(entity, months);
		this.setState({
			entities: [...entities, entity],
			baseEntity: entity.entity
		})
	}

	addAnother = () => {
		let { entities, months } = this.state;
		const newEntity = this.formatEntity(sample[entities.length], months);
		this.setState({
			entities: [...entities, newEntity],
			baseEntity: newEntity.entity
		})
	}
	
	deleteEntity = (id, type) => {
		let { entities, baseEntity } = this.state;
		entities = entities.filter(e=>(e.id !== id));
		baseEntity = entities.length > 0 ? baseEntity : null; // reset type filter when there are no selected elements
		this.setState({
			entities,
			baseEntity
		})
	}
	
	formatEntity = (entity, months) => {
		const { code, entity: entity_type, first_released, name_compare } = entity;
		const dateStart = moment(first_released).endOf('month');
		const dateEnd = dateStart.clone().add(months, 'months').endOf('month');
		
		return {
			id: code,
			entity: entity_type,
			title: name_compare,
			dateStart: dateStart.format('YYYY-MM-DD'),
			dateEnd: dateEnd.format('YYYY-MM-DD')		
		}
	}


	componentDidMount(){
	}
	


	componentWillUnmount() {
	}
	
	componentDidUpdate(prevProps) {
	}
	
	renderSearchBox() {
		const { baseEntity } = this.state;
		const entityTypes = baseEntity ? [baseEntity] : ['projects', 'products', 'tracks'];
		const placeholder = `Search ${entityTypes.join(', ')}...`
		return <SearchWidget searchResult={this.addEntity} placeholder={placeholder} entityTypes={entityTypes} baseEntity mode="playlist" />
	}
	
	renderEntities(entities){
		if(!Array.isArray(entities) || !entities.length)
			return null;
		const type = this.state.baseEntity;
		return <div key={`${type}`} className={`page-filter ${type}`}>
			<div className="tag-list">
				<div className="page-filter-item">
					<div className="page-filter-list">
						{entities.map(entity=><div key={entity.id} className="tag">
							<div className="tag-name-holder">
								<div className="tag-name">
									<span>{entity.title}</span>
								</div>
								<a
									className="close-link"
									onClick={()=>this.deleteEntity(entity.id, type)}
								>
									&times;
								</a>
							</div>
						</div>)}
					</div>
				</div>
			</div>
		</div>

	}

	
	render() {
		const { entities = [] } = this.state;
		return <div className="wrapper wrapper-content light-blue-bg">
			<div className="todo">
				{this.renderSearchBox()}
				{this.renderEntities(entities)}
				<button type="button" onClick={this.addAnother}>Quick Add</button>
			</div>
			
			{entities.length > 0 && <div className="todo">
				<IncomeChart entities={entities} />
			</div>}
			
			{/*
			<div className="comparison-wrapper">
				{entities.map(entity=><ComparisonDetails key={entity.id} entity={entity} />)}
			</div>
			*/}
			<ComparisonRows entities={entities} />
		</div>

	}
	
}

function mapStateToProps(state) {
	return {
	}
}


export default withRouter(connect(mapStateToProps)(ComparisonList));